// Athlete profile data — Kaleb Jones (Class of 2027).
export const athlete = {
  firstName: "Kaleb",
  lastName: "Jones",
  jerseyNumber: "15",
  jerseyNumberHS: "12",
  jerseyNumberAAU: "11",
  position: "Point Guard / Shooting Guard",
  positionShort: "PG / SG",
  gradYear: "2027",
  height: "5'8\"",
  weight: "165 lbs",
  hometown: "Wake Forest, NC",
  highSchool: "Wake Forest High School",
  club: "DB Elite 17U",
  headline:
    "Defensive-minded guard who controls pace and makes advanced reads out of ball screens.",
  subline:
    "Disciplined on-ball defender with composure and strong decision-making in key moments.",
  honors:
    "Top 6 in Steals — Northern Six 6A/7A • Player of the Game",
  profileImage: "https://i.imgur.com/t7rmXbx.png",
  heroBackground:
    "https://images.unsplash.com/photo-1563506644863-444710df1e03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxiYXNrZXRiYWxsJTIwY291cnQlMjBkYXJrJTIwbW9vZHl8ZW58MHx8fHwxNzc5NTQzOTM2fDA&ixlib=rb-4.1.0&q=85",
};

export const film = {
  highlight: {
    title: "Junior Highlights | Class of 2027",
    duration: "—",
    thumbnail:
      "https://customer-assets.emergentagent.com/job_player-hub-102/artifacts/2q69201r_Junior_Highlights.png",
    url: "http://www.hudl.com/v/2TxDXU",
  },
  clips: [
    {
      title: "Full Game vs. Sanderson",
      jersey: "12",
      duration: "—",
      thumbnail:
        "https://customer-assets.emergentagent.com/job_player-hub-102/artifacts/x2ynvm6i_Screenshot_Full_Game.png",
      url: "https://drive.google.com/file/d/14q59xTf0I9gM97p31lZapdtpunru20Sc/view?usp=sharing",
    },
  ],
};

export const stats = {
  season: "High School (2025–26) — Wake Forest HS",
  defensiveImpact: "Defensive Impact: Top 6 in Steals — Northern Six 6A/7A.",
  items: [
    { label: "GP", value: "24", caption: "Games Played" },
    { label: "PPG", value: "5.1", caption: "Points / Game" },
    { label: "APG", value: "2.2", caption: "Assists / Game" },
    { label: "RPG", value: "2.3", caption: "Rebounds / Game" },
    { label: "STL/G", value: "1.5", caption: "Steals / Game" },
    { label: "FG%", value: "42", caption: "Field Goal %" },
  ],
};

export const teams = [
  {
    type: "High School",
    program: "Wake Forest HS — Wake Forest, NC",
    role: "PG/SG · #15",
    coachName: "Gregory E. Ackles Jr.",
    coachTitle: "Head Coach, Wake Forest HS",
    coachEmail: "gackles@wcpss.net",
    coachPhone: "(919) 271-7253",
  },
  {
    type: "Club",
    program: "DB Elite 17U — PUMA PRO16 NXTPRO",
    role: "PG/SG · #11",
    coachName: "Camden Scott",
    coachTitle: "Coach, DB Elite 17U",
    coachEmail: "dreambigelitebasketball@gmail.com",
    coachPhone: "(919) 696-7418 (Preferred)",
  },
];

export const events = [
  {
    date: "Nov",
    year: "2026",
    name: "2026–27 Senior Season",
    location: "Wake Forest High School",
    tag: "High School Basketball",
    liveStream: "",
    team: "Wake Forest HS",
    circuit: "",
    jersey: "15",
    seasonSchedule: true,
  },
];

// Individual game records for the 2026–27 Wake Forest HS senior season.
// Each record is editable; `tba` marks tournament games with unknown opponent/time/location.
export const seniorSeasonMeta = {
  team: "Wake Forest HS",
  label: "2026–27 Senior Season",
  sport: "High School Basketball",
  seasonStart: "November 2026",
};

export const seniorSchedule = [
  { date: "2026-11-12", time: "6:30 PM", opponent: "Rolesville", type: "Home", venue: "Wake Forest High School", city: "Wake Forest", state: "NC", conference: false, tournament: "", tba: false },
  { date: "2026-11-20", time: "6:30 PM", opponent: "Enloe", type: "Home", venue: "Wake Forest High School", city: "Wake Forest", state: "NC", conference: false, tournament: "", tba: false },
  { date: "2026-11-24", time: "6:30 PM", opponent: "Wakefield", type: "Away", venue: "Wakefield High School", city: "Raleigh", state: "NC", conference: false, tournament: "", tba: false },
  { date: "2026-12-05", time: "5:30 PM", opponent: "Clayton", type: "Neutral", venue: "Wakefield High School", city: "Raleigh", state: "NC", conference: false, tournament: "", tba: false },
  { date: "2026-12-09", time: "6:30 PM", opponent: "Apex", type: "Away", venue: "Apex High School", city: "Apex", state: "NC", conference: false, tournament: "", tba: false },
  { date: "2026-12-11", time: "7:45 PM", opponent: "Wake Prep Academy", type: "Home", venue: "Wake Forest High School", city: "Wake Forest", state: "NC", conference: false, tournament: "", tba: false },
  { date: "2026-12-15", time: "6:30 PM", opponent: "Cary", type: "Home", venue: "Wake Forest High School", city: "Wake Forest", state: "NC", conference: false, tournament: "", tba: false },
  { date: "2026-12-19", time: "2:30 PM", opponent: "Rocky Mount", type: "Neutral", venue: "Southern Nash High School", city: "", state: "", conference: false, tournament: "", tba: false },
  { date: "2026-12-21", time: "3:00 PM", opponent: "Discovery Charter", type: "Neutral", venue: "TBA", city: "", state: "", conference: false, tournament: "South Granville Christmas Tournament", tba: true },
  { date: "2026-12-22", time: "TBA", opponent: "TBA", type: "Neutral", venue: "TBA", city: "", state: "", conference: false, tournament: "South Granville Christmas Tournament", tba: true },
  { date: "2026-12-23", time: "TBA", opponent: "TBA", type: "Neutral", venue: "TBA", city: "", state: "", conference: false, tournament: "South Granville Christmas Tournament", tba: true },
  { date: "2026-12-28", time: "2:30 PM", opponent: "TMSA", type: "Neutral", venue: "TBA", city: "", state: "", conference: false, tournament: "Bunn Christmas Tournament", tba: true },
  { date: "2026-12-29", time: "TBA", opponent: "TBA", type: "Neutral", venue: "TBA", city: "", state: "", conference: false, tournament: "Bunn Christmas Tournament", tba: true },
  { date: "2026-12-30", time: "TBA", opponent: "TBA", type: "Neutral", venue: "TBA", city: "", state: "", conference: false, tournament: "Bunn Christmas Tournament", tba: true },
  { date: "2027-01-08", time: "7:45 PM", opponent: "Vance County", type: "Away", venue: "Vance County High School", city: "Henderson", state: "NC", conference: true, tournament: "", tba: false },
  { date: "2027-01-15", time: "7:45 PM", opponent: "East Wake", type: "Home", venue: "Wake Forest High School", city: "Wake Forest", state: "NC", conference: true, tournament: "", tba: false },
  { date: "2027-01-20", time: "7:45 PM", opponent: "Heritage", type: "Away", venue: "Heritage High School", city: "Wake Forest", state: "NC", conference: true, tournament: "", tba: false },
  { date: "2027-01-22", time: "7:45 PM", opponent: "Knightdale", type: "Away", venue: "Knightdale High School", city: "Knightdale", state: "NC", conference: true, tournament: "", tba: false },
  { date: "2027-01-26", time: "7:45 PM", opponent: "Franklinton", type: "Home", venue: "Wake Forest High School", city: "Wake Forest", state: "NC", conference: true, tournament: "", tba: false },
  { date: "2027-01-29", time: "7:45 PM", opponent: "Vance County", type: "Home", venue: "Wake Forest High School", city: "Wake Forest", state: "NC", conference: true, tournament: "", tba: false },
  { date: "2027-02-02", time: "7:45 PM", opponent: "East Wake", type: "Away", venue: "East Wake High School", city: "Wendell", state: "NC", conference: true, tournament: "", tba: false },
  { date: "2027-02-04", time: "7:45 PM", opponent: "Heritage", type: "Home", venue: "Wake Forest High School", city: "Wake Forest", state: "NC", conference: true, tournament: "", tba: false },
  { date: "2027-02-05", time: "7:45 PM", opponent: "Heritage", type: "Home", venue: "Wake Forest High School", city: "Wake Forest", state: "NC", conference: true, tournament: "", tba: false },
  { date: "2027-02-09", time: "7:45 PM", opponent: "Knightdale", type: "Home", venue: "Wake Forest High School", city: "Wake Forest", state: "NC", conference: true, tournament: "", tba: false },
  { date: "2027-02-12", time: "7:45 PM", opponent: "Franklinton", type: "Away", venue: "Franklinton High School", city: "Franklinton", state: "NC", conference: true, tournament: "", tba: false },
];

export const pastEvents = [
  {
    date: "Aug 9",
    year: "2026",
    name: "Catawba College – 2026 Elite Camp",
    location: "Salisbury, NC",
    tag: "Camp",
    team: "Individual Showcase",
    circuit: "",
    jersey: "15",
    venue: "Goodman Gym, 2254 Yost St, Salisbury, NC",
    schedule: "1:00 PM – 5:00 PM",
  },
  {
    date: "Aug 6",
    year: "2026",
    name: "UNC Pembroke – High School Elite Camp",
    location: "Pembroke, NC",
    tag: "Camp",
    team: "Individual Showcase",
    circuit: "",
    jersey: "15",
    venue: "Jones Center at UNC Pembroke",
    schedule: "1:00 PM – 5:00 PM",
  },
  {
    date: "Jul 9–12",
    year: "2026",
    name: "NXT Pro Session 11",
    location: "Richmond, VA",
    tag: "Club",
    team: "DB Elite 17U",
    circuit: "NXT Pro / Made Hoops",
    jersey: "11",
  },
  {
    date: "Jun 13–14",
    year: "2026",
    name: "2026 NC Live Team Camp (NCAA Live Period)",
    location: "Bermuda Run, NC",
    tag: "High School",
    team: "Wake Forest",
    circuit: "",
    jersey: "15",
    venue: "Rise Indoor Sports",
    schedule:
      "June 13 (Session 5): 5:30 PM (Court 7); 7:30 PM (Court 7)\nJune 14 (Session 7): 1:30 PM (Court 7); 3:30 PM (Court 6)",
  },
];

export const academics = {
  gpa: "3.2 / 3.6",
  gpaScale: "Unweighted / Weighted",
  coursework: "All Honors curriculum",
  academicFocus:
    "Academy of Construction and Design Careers (Engineering Track)",
  intendedMajor: "Engineering",
  activities: [
    "ACE Mentorship",
    "National Achievers Society",
    "NSBE Jr.",
    "NSHSS",
    "BSU - President",
    "Community Volunteer",
    "NTHS",
  ],
  testScores: "Available upon request",
  positioningStatement:
    "High-academic student-athlete with consistent academic performance and athletic recognition.",
  awards: {
    academic: [
      { text: "A/B Honor Roll (2023–2026)" },
      {
        text: "Varsity Letter & Academic All-Conference — Basketball (2024, 2025)",
      },
      {
        text: "Student of the Week (May 2026)",
        linkLabel: "Read Article",
        url: "https://forestfireonline.com/student-life/2026/05/07/student-of-the-week-kaleb-jones/",
      },
    ],
    athletic: [
      { text: "JV MVP (2023–2024)" },
      { text: "6× “Player of the Game” selections (2023–2026)" },
    ],
    leadership: [
      {
        text: "Architecture, Construction & Engineering (ACE) Team Presentation — Acknowledgement of Sustainability",
      },
    ],
  },
};

export const additionalInfo = {
  ncaaId: "2402220659",
};

export const playerProfiles = [
  {
    name: "MaxPreps",
    handle: "kaleb-jones",
    url: "https://www.maxpreps.com/nc/wake-forest/wake-forest-cougars/athletes/kaleb-jones/?careerid=ab2govijkf0ee",
    description: "Full season stats, game logs and team records.",
  },
  {
    name: "Hudl",
    handle: "Kaleb-Jones",
    url: "https://www.hudl.com/profile/24686439/Kaleb-Jones",
    description: "Full game film, breakdowns and verified highlights.",
  },
];

export const contact = {
  email: "kalebjones.recruiting@gmail.com",
  phone: "919-454-3803",
  instagram: "getbuckets_kj",
  guardianName: "Khalilah Allen-Jones (Parent)",
  guardianEmail: "kallenjones@gmail.com",
  guardianPhone: "(919) 656-6618",
};
